const protocol = window.location.protocol

export const getApiUrl = process.env.NODE_ENV === "production"
	? protocol + "//api.o4biz.ru"
	: protocol + "//api.marmelad.ru"

export const getStaticUrl = process.env.NODE_ENV === "production"
	? protocol + "//static.o4biz.ru"
	: protocol + "//static.marmelad.ru"